import { MutationTree } from 'vuex';
import { FlowDesignerState } from '..';
import {
	SET_TRIGGER,
	UPDATE_SCHEDULE_CONDITION,
	UPDATE_TRIGGER_CONDITIONS,
	UPDATE_AUDIENCE_CONDITIONS,
	UPDATE_TARGET_CONTACT_TYPES
} from './mutationTypes';
import { ConditionGroupViewModel } from '@/shared/components/conditions/models/conditionGroupViewModel';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';

export const mutations: MutationTree<FlowDesignerState> = {

	[SET_TRIGGER](state, trigger: string) {
		if (trigger) {
			state.currentFlow.triggers = [trigger];
		} else {
			state.currentFlow.triggers = []; // if a toggle happens
		}
	},

	[UPDATE_SCHEDULE_CONDITION](state, { condition, openingTimes }) {
		if (condition) {
			state.currentFlow.scheduleCondition = condition;
		} else {
			state.currentFlow.scheduleCondition = {} as ConditionViewModel;
		}
		state.currentFlow.businessHours = openingTimes;
	},

	[UPDATE_TRIGGER_CONDITIONS](state, conditionGroup: ConditionGroupViewModel) {
		state.currentFlow.triggerConditions = conditionGroup;
	},

	[UPDATE_AUDIENCE_CONDITIONS](state, conditionGroup: ConditionGroupViewModel) {
		state.currentFlow.audienceConditions = conditionGroup;
	},

	[UPDATE_TARGET_CONTACT_TYPES](state, contactTypes: string[]) {
		state.currentFlow.targetContactTypes = contactTypes;
	},
};
